<div class="fixed top-4 right-4 z-50 w-full max-w-sm space-y-2">
  <div
    *ngFor="let toast of toasts"
    [ngClass]="getToastClass(toast.type)"
    class="toast-enter"
  >
    <div class="flex-1">{{ toast.message }}</div>
    <button
      (click)="remove(toast.id)"
      class="ml-4 text-white hover:text-gray-200 focus:outline-none"
    >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</div>













